module.exports = __webpack_public_path__ + "static/media/grade8.7be1ad2d.jpg";